import { preventSave, showHotImage } from '@/store/setting'
import { useViewStack } from './useViewStack'
import { watchEffect } from 'vue'

export const closeCurrentHotImage = () => {
  useViewStack(() => {
    let oldShowHotImage = showHotImage.value
    preventSave.value = true
    showHotImage.value = false

    return () => {
      showHotImage.value = oldShowHotImage
      preventSave.value = false
    }
  })
}
